import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as SocioService from 'services/socio.service'

const Select2ProveedorInput = ({ id, onChange }) => {
  const loadSociosSelect = React.useCallback((inputValue, resolve) => {
    SocioService.obtenerSociosAsSelect2(inputValue)
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  return <AsyncSelect selectId={id} loadOptions={loadSociosSelect} onChange={onChange} />
}

export default React.memo(Select2ProveedorInput)
